// Must agree with NOT_APPLICABLE in inrange_agents/portfolio_row.py: an agent whose own
// row says it is not involved in the project owes nothing and works nothing there.
export const NOT_APPLICABLE = "NOT APPLICABLE";

export const isStoodDown = (row: { lifecycle: string } | null | undefined): boolean =>
  row?.lifecycle === NOT_APPLICABLE;

/** The specialists working the project, in team order (the order the project status
 * route returns them): those keeping a status row and not stood down from it. */
export const workingSpecialists = <
  T extends { keeps_status_row: boolean; row: { lifecycle: string } | null },
>(
  agents: T[],
): T[] => agents.filter((a) => a.keeps_status_row && !isStoodDown(a.row));
